import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Button } from 'react-bootstrap';
import ImageCenter from '../ImageCenter/ImageCenter';
import './BankSelection.scss';
import authenticationMethods from './methods';
import banksImages from './banksImages';


class BankSelection extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selected: ''
    };
  }

  getBankImage(logo) {
    return banksImages[logo];
  }

  render() {
    const { onBackButtonClicked, requestAuthentication, showBackButton, createUserIfNotExists, t } = this.props;
    return (
      <div className={'bank-selection-view mContent'}>
        <h1 tabIndex={0} id={'bank-selection-title'}>{t('bankSelection.title')}</h1>

        <div className="info">{t('bankSelection.text')}</div>

        <div className={'bank-selection'}>
          {authenticationMethods.map(bank => (
            <Button className={'mButtonBank'} active={this.state.selected === bank.id} key={bank.id} onClick={() => { requestAuthentication(bank.method, createUserIfNotExists); this.setState({ selected: bank.id }) }}>
              <div className={'logo'}>
                <ImageCenter alt="bank-selection-image" url={this.getBankImage(bank.logo)} />
              </div>
              <div>{bank.name}</div>
            </Button>
          ))}
        </div>
        { showBackButton &&
          <div className={'back-button'}>
            <Button onClick={onBackButtonClicked}>
              {t('bankSelection.backButton')}
            </Button>
          </div>
        }
      </div>
    );
  }
}

BankSelection.propTypes = {
  onBackButtonClicked: PropTypes.func,
  requestAuthentication: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool,
  createUserIfNotExists: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

BankSelection.defaultProps = {
  onBackButtonClicked: () => {},
  showBackButton: true
};

export default translate(['identification'])(BankSelection);



// WEBPACK FOOTER //
// ./src/components/BankSelection/BankSelection.jsx